import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuGroup: [],
    roleGroup: [],
    departmentGroup: []
  },
  mutations: {
    saveMenuGroup(state, val) {
      state.menuGroup = [];
      let groupList = Object.assign([], val);
      for (let i in groupList) {
        state.menuGroup.push({ ID: groupList[i].id, Name: groupList[i].name });
      }
    },
    saveRoleGroup(state, val) {
      state.roleGroup = [];
      let groupList = Object.assign([], val);
      for (let i in groupList) {
        state.roleGroup.push({ ID: groupList[i].id, Name: groupList[i].name });
      }
    },
    saveDepartmentGroup(state, val) {
      state.departmentGroup = [];
      let groupList = Object.assign([], val);
      for (let i in groupList) {
        state.departmentGroup.push({
          ID: groupList[i].id,
          Name: groupList[i].full_name
        });
      }
    }
  },
  actions: {},
  modules: {}
});
